import React from 'react'
import { Form, Input } from 'antd'


const S3ResourceForm = ({ form, onFinish, initialValues, ...props }) => {
  return (
    <Form
      component={false}
      form={form}
      initialValues={initialValues}
      onFinish={onFinish}
      labelCol={{span:24}}
      layout='inline'
      {...props}
    />
  )
}

export const FormS3Resource = ({ form, initialValues, onFinish }) => {
  return (
    <>
      <S3ResourceForm
        form={form}
        initialValues={initialValues}
        onFinish={onFinish}
      >
          <Form.Item
            name='url'
            rules={[{ type: 'string', required: true }]}
            noStyle
          >
            <Input placeholder='KR URL'/>
          </Form.Item>
      </S3ResourceForm>
    </>
  )
}
